import { ensureNamespace } from '@/lib/i18n/runtime';
import { createFileRoute } from '@tanstack/react-router';
import { TikTokCallback } from '@/features/tiktok/components/TikTokCallback';
export const Route = createFileRoute('/_auth/tiktok-callback')({ beforeLoad: async () => { await Promise.all([ensureNamespace('shell'), ensureNamespace('tiktok')]).catch(() => { /* Boundary provides retry. */ }); }, component: TikTokCallback });
